import { Injectable } from '@angular/core';
import { TagTemplate } from 'src/app/_model/tag-template';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import {
  DbPersistenceService, Query
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { TagTemplatesDaoService } from '../tag-templates-dao.service';
import { TagTemplateDbTableDefinition } from './tag-template-db-table-definition';

@Injectable()
export class TagTemplatesDbDaoService implements TagTemplatesDaoService {
  // Private Member
  private db: Promise<any>;

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private tagTemplateTableDefinition: TagTemplateDbTableDefinition,
  ) { }

  async saveTagTemplates(tagTemplates: TagTemplate[]): Promise<void> {
    try {
      const db = await this.db;

      const queries: Query[] = [];
      tagTemplates?.forEach(tagTemplate => {
        queries.push({
          statement:
            `INSERT OR REPLACE INTO ${this.tagTemplateTableDefinition.tableName} (id, label, databag) VALUES (?,?,?)`,
          parameters: [
            Number(tagTemplate.isLocal() ? tagTemplate.id.secondaryId : tagTemplate.id.imsId),
            tagTemplate.label,
            tagTemplate.databag ? JSON.stringify(tagTemplate.databag) : undefined,
          ]
        });
      });
      await this.dbPersistenceService.executeBatch(db, queries);

    } catch (error) {
      this.logger.log('Error saving tagtemplates to db', error, '-', error.message);
    }
  }

  async reset(): Promise<void> { }

  async clear(): Promise<void> {
    const db = await this.db;
    await this.dbPersistenceService.truncateTable(db, this.tagTemplateTableDefinition.tableName);
  }

}
